<div class="pii-pdf-viewer-container">
  <div class="pii-pdf-label" *ngIf="showLabel && reportTitle">
    <label class="form-label">{{ reportTitle }}</label>
  </div>
  
  <div class="pii-pdf-content">
    <!-- Masked state - show buttons to view/download -->
    <div class="pii-pdf-masked" *ngIf="!isUnmasked">
      <div class="masked-overlay">
        <div class="overlay-content">
          <i class="feather icon-file-text overlay-icon"></i>
          <h6 class="overlay-title">{{ reportTitle }}</h6>
          <p class="overlay-text">This report contains PII data and requires justification to view</p>
          
          <div class="action-buttons">
            <button 
              *ngIf="canViewReport" 
              type="button" 
              class="btn btn-primary me-2"
              (click)="onViewReport()"
              [disabled]="isLoading">
              <i class="feather icon-eye" *ngIf="!isLoading"></i>
              <span *ngIf="isLoading" class="spinner-border spinner-border-sm me-2" role="status"></span>
              {{ buttonText }}
            </button>
          </div>
        </div>
      </div>
    </div>
    
    <!-- Unmasked state - show PDF viewer and controls -->
    <div class="pii-pdf-unmasked" *ngIf="isUnmasked">
      <div class="pdf-controls">
        <div class="controls-left">
          <span class="badge bg-success">
            <i class="feather icon-unlock"></i>
            Report Unmasked
          </span>
        </div>
        
        <div class="controls-right">
          
          <button 
            *ngIf="canDownload && downloadable" 
            type="button" 
            class="btn btn-sm btn-outline-success me-2"
            (click)="onDownload()"
            title="Download Report">
            <i class="feather icon-download"></i>
            {{ downloadText }}
          </button>
          
          <button 
            type="button" 
            class="btn btn-sm btn-outline-secondary"
            (click)="onHide()"
            title="Hide Report">
            <i class="feather icon-eye-off"></i>
            Hide
          </button>
        </div>
      </div>
      
      <!-- PDF viewer using ng2-pdf-viewer (like the original implementation) -->
      <div class="pdf-viewer-container">
        <img [src]="decryptedUrl" height="100%">
      </div>
    </div>
    
    <!-- Security notice when unmasked -->
    <div class="pii-security-notice" *ngIf="isUnmasked && useIndividualUnmask">
      <small class="text-warning">
        <i class="feather icon-shield"></i>
        Report access logged • Auto-hide in 2 minutes
      </small>
    </div>
  </div>
</div>
